var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36682 7.51693C3.28904 7.51693 3.21415 7.50293 3.14215 7.47493C3.06971 7.44737 3.00571 7.40582 2.95015 7.35026L0.166819 4.56693C0.066819 4.46693 0.0194858 4.34737 0.0248191 4.20826C0.0305969 4.06959 0.0779301 3.95026 0.166819 3.85026C0.266819 3.75026 0.386375 3.70026 0.525486 3.70026C0.664152 3.70026 0.77793 3.75026 0.866819 3.85026L3.36682 6.35026L9.13349 0.583594C9.22238 0.483594 9.33904 0.433594 9.48349 0.433594C9.62793 0.433594 9.7446 0.483594 9.83349 0.583594C9.93349 0.683594 9.98349 0.802927 9.98349 0.941594C9.98349 1.08071 9.93349 1.20026 9.83349 1.30026L3.78349 7.35026C3.72793 7.40582 3.66415 7.44737 3.59215 7.47493C3.51971 7.50293 3.4446 7.51693 3.36682 7.51693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.0764d01583ed6fe533ceaaa13cd0c3a6.svg";
export { ForwardRef as ReactComponent };